import { useCallback } from 'react';
import { useAppSelector } from './useAppStore';
import { isPlatformAdminRole } from '../utils/roles';

export function usePermissions() {
  const user = useAppSelector((s) => s.auth.user);

  const hasPermission = useCallback(
    (permission: string): boolean => {
      if (!user) return false;
      return user.effectivePermissions.includes(permission);
    },
    [user],
  );

  const hasAnyPermission = useCallback(
    (...permissions: string[]): boolean => permissions.some((p) => hasPermission(p)),
    [hasPermission],
  );

  const hasRole = useCallback(
    (...roles: string[]): boolean => !!user && roles.includes(user.role),
    [user],
  );

  const isPlatformAdmin = isPlatformAdminRole(user?.role);
  const isOfficeAdmin   = user?.role === 'office_admin';
  const isAgent         = user?.role === 'agent';

  return { hasPermission, hasAnyPermission, hasRole, user, isPlatformAdmin, isOfficeAdmin, isAgent };
}
